module.exports = __webpack_public_path__ + "img/2021AllotteeOthers.98774853.jpg";